export const UserShopInfoApi = 'wx/usershopinfo/' // 用户微信店铺信息
export const ShopQRCodeApi = 'wx/WeChatQRCode/' // 店铺二维码
export const BeautyPackageApi = 'wx/wechatbeautypackage/' // 店铺储值套餐
export const VipRechargePackageApi = 'wx/wechatviprechargepackage/' // 店铺美容套餐
export const ShopProjectApi = 'wx/wechatshopproject/' // 店铺服务项目
export const BulkCouponApi = 'wx/wechatbulkcoupon/' // 店铺会员领取优惠券列表
export const PreferentialSalesApi = 'wx/preferentialsales/' // 店铺优惠咨询列表
export const MessageApi = 'wx/message/' // 消息通知